//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeaderNav',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      search: null
    }
  }
}
